module.exports = __webpack_public_path__ + "static/img/gengxin.b26b2ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/gengxin.png
// module id = Gfx/
// module chunks = 24